import React, { FC, useContext } from "react";
import "./index.css";
import LanguageSelect from "../../../Components/LanguageSelect";
import { ILocalizationContext } from "../../../Localization/Models/ILocalizationContext";
import LocalizationContext from "../../../Localization/LanguageContext";
import { saifUrl } from "@saif/core";
import { Button } from "@saif/button";
import { Logo } from "@saif/logo";
import { buildMailtoHref } from "@saif/validate-email"
import { buildTelHref } from "@saif/validate-phone"

interface Props {}

const Header: FC<Props> = () => {
  const { getValue } = useContext(LocalizationContext) as ILocalizationContext;
  return (
    <>
      <div className="confirmation-header bg-evergreen">
        <div className="confirmation-content container">
          <div id="HeaderTagLine">{getValue("Header", "LeftSection")}</div>
          <div className="confirmation-header-buttons">
            <LanguageSelect />
            <Button
              as="a"
              variant="text"
              color="primary"
              size="sm"
              iconProps={{ variant: "phone" }}
              href={buildTelHref(getValue("Header", "PhoneValue"))}
            >
              {getValue("Header", "PhoneDisplay")}
            </Button>
            <Button
              as="a"
              variant="text"
              color="primary"
              size="sm"
              iconProps={{ variant: "envelope" }}
              href={buildMailtoHref("saifinfo@saif.com")}
            >
              Email
            </Button>
            <Button
              as="a"
              variant="text"
              color="primary"
              size="sm"
              iconProps={{ variant: "comment" }}
              href={getValue("Header", "FeedbackValue")}
              target="_blank"
            >
              {getValue("Header", "FeedbackDisplay")}
            </Button>
          </div>
        </div>
      </div>
      <div className="logo-header bg-white">
        <div className="logo-content container px-0 py-3">
          <Logo
            width="143px"
            withTagline={true}
            linkProps={{ href: saifUrl }}
          />
        </div>
      </div>
    </>
  );
};

export default Header;
